import { render, staticRenderFns } from "./AddTabAdminAccount.vue?vue&type=template&id=7867209f&scoped=true"
import script from "./AddTabAdminAccount.vue?vue&type=script&lang=js"
export * from "./AddTabAdminAccount.vue?vue&type=script&lang=js"
import style0 from "./AddTabAdminAccount.vue?vue&type=style&index=0&id=7867209f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7867209f",
  null
  
)

export default component.exports